import React, { useEffect, useState } from 'react'
import useFetch from 'use-http'

import { Box, Button, Card, Heading, Inline, Modal, Stack, TextField } from '@myxplor/stardust'

interface Props {
  account: Papi.Account
  isOpen: boolean
  onCancel(): void
  onSave(service: Papi.Service): void
}

const ServiceModal = ({ account, isOpen, onCancel, onSave }: Props) => {
  const [serviceModel, setServiceModel] = useState<Nullable<Record<string, any>>>(null)

  const serviceRequest = useFetch(`/api/v1/accounts/${account.id}/services`)

  const onChange = (field: string, value: number | string) => {
    setServiceModel((model: any) => ({ ...model, [field]: value }))
  }

  const handleSave = async () => {
    if (serviceModel) {
      const response = await serviceRequest.post(serviceModel)

      onSave(response.data)
    }
  }

  useEffect(() => setServiceModel({}), [isOpen])

  if (!serviceModel) {
    return null
  }

  const isValid = !!serviceModel.origin_id && !!serviceModel.name && !!serviceModel.contact_email

  return (
    <Modal backdrop isOpen={isOpen} onBlur={onCancel}>
      <Card>
        <Box minWidth={600} padding="small">
          <Stack space="small">
            <Heading level={5}>Service</Heading>
            <TextField
              label="Original ID"
              name="origin_id"
              placeholder="The external ID for the service in the original BMS"
              required
              value={serviceModel.origin_id || ''}
              onChange={(value) => onChange('origin_id', value)}
            />
            <TextField
              label="Name"
              name="name"
              placeholder="Display name for this service within Starmap"
              required
              value={serviceModel.name || ''}
              onChange={(value) => onChange('name', value)}
            />
            <TextField
              label="Contact Email"
              name="contact_email"
              placeholder="Contact email address to send onboarding emails to"
              required
              value={serviceModel.contact_email || ''}
              onChange={(value) => onChange('contact_email', value)}
            />
            <Inline align="right" space="small">
              <Button variant="outline" onClick={onCancel}>
                Cancel
              </Button>
              <Button disabled={!isValid} onClick={handleSave}>
                Save
              </Button>
            </Inline>
          </Stack>
        </Box>
      </Card>
    </Modal>
  )
}

export default React.memo(ServiceModal)
